export default "__VITE_ASSET__FsGJ1Au$__"